import { Document } from '../../../graphql/graphql';

interface SubmissionStatusMap {
	translation: string;
}

export const SUBMISSION_STATUS_KEYS = {
	UNPROCESSED: 'UNPROCESSED',
	FILE_MISSING: 'FILE_MISSING',
	TAKEN_OVER: 'TAKEN_OVER',
	MEDDI_FAIL: 'MEDDI_FAIL',
	CSSZ_FAIL: 'CSSZ_FAIL',
	CSSZ_PROCESSING: 'CSSZ_PROCESSING',
	CSSZ_REJECTED: 'CSSZ_REJECTED',
	CSSZ_ACCEPTED: 'CSSZ_ACCEPTED',
	CSSZ_NOT_SENT: 'CSSZ_NOT_SENT',
	CSSZ_FINISHED: 'CSSZ_FINISHED',
	FINISHED: 'FINISHED',
	CANCELLED: 'CANCELLED',
} as const;

const SUBMISSION_STATUS_MAP: Record<
	keyof typeof SUBMISSION_STATUS_KEYS,
	SubmissionStatusMap
> = {
	UNPROCESSED: {
		translation:
			'component.CSSZSickLeaveCertificateSubmissionsOverview.statusUnprocessed',
	},
	FILE_MISSING: {
		translation:
			'component.CSSZSickLeaveCertificateSubmissionsOverview.statusFileMissing',
	},
	TAKEN_OVER: {
		translation:
			'component.CSSZSickLeaveCertificateSubmissionsOverview.statusTakenOver',
	},
	MEDDI_FAIL: {
		translation:
			'component.CSSZSickLeaveCertificateSubmissionsOverview.statusMeddiFail',
	},
	CSSZ_FAIL: {
		translation:
			'component.CSSZSickLeaveCertificateSubmissionsOverview.statusCsszFail',
	},
	CSSZ_PROCESSING: {
		translation:
			'component.CSSZSickLeaveCertificateSubmissionsOverview.statusCsszProcessing',
	},
	CSSZ_REJECTED: {
		translation:
			'component.CSSZSickLeaveCertificateSubmissionsOverview.statusCsszRejected',
	},
	CSSZ_ACCEPTED: {
		translation:
			'component.CSSZSickLeaveCertificateSubmissionsOverview.statusCsszAccepted',
	},
	CSSZ_NOT_SENT: {
		translation:
			'component.CSSZSickLeaveCertificateSubmissionsOverview.statusCsszNotSent',
	},
	CSSZ_FINISHED: {
		translation:
			'component.CSSZSickLeaveCertificateSubmissionsOverview.statusCsszFinished',
	},
	FINISHED: {
		translation:
			'component.CSSZSickLeaveCertificateSubmissionsOverview.statusFinished',
	},
	CANCELLED: {
		translation:
			'component.CSSZSickLeaveCertificateSubmissionsOverview.statusCancelled',
	},
};

export const getSubmissionLastItemStatus = (item: Document) => {
	const items = item?.items ?? [];
	const lastItem = items[items.length - 1];
	const status = lastItem?.extra?.status;

	return typeof status === 'string' ? status : undefined;
};

export const getSubmissionStatus = (item: Document) => {
	const status = getSubmissionLastItemStatus(item);

	return status
		? SUBMISSION_STATUS_MAP[status as keyof typeof SUBMISSION_STATUS_MAP]
		: null;
};

export const getSickLeaveStatusTranslationKey = (
	status: string | undefined,
): string | null => {
	if (!status) {
		return null;
	}

	return (
		SUBMISSION_STATUS_MAP[status as keyof typeof SUBMISSION_STATUS_MAP]
			?.translation ?? null
	);
};

export const isRefreshAllowed = (status: string | undefined): boolean => {
	return (
		status === SUBMISSION_STATUS_KEYS.MEDDI_FAIL ||
		status === SUBMISSION_STATUS_KEYS.CSSZ_FAIL
	);
};
